// app/javascript/packs/application.js

import Rails from "@rails/ujs";
import * as ActiveStorage from "@rails/activestorage";
import "channels";
import ReactRailsUJS from "../react_ujs"; // Import from the local file

// Support component names relative to this directory:
const componentRequireContext = require.context("components", true);
// console.log(componentRequireContext.keys()); // Optional: Log component keys
ReactRailsUJS.useContext(componentRequireContext);

// Start Rails UJS and ActiveStorage
Rails.start();
ActiveStorage.start();

// Hide error messages after 6 seconds
setTimeout(function () {
  const errorMessages = document.getElementById("error-messages");
  if (errorMessages) {
    errorMessages.style.display = "none";
  }
}, 6000);
